import React from 'react';
import {fromSystemDateTime, toHumanDateTime} from '../utils/date';

const StatusItem = ({status}) => {
    if (status === 'approved') {
        return (
            <span className="text-bold text-success" style={{whiteSpace: 'nowrap'}}>
                <i className="fa fa-fw fa-check"></i> {window.__js_bid_reviews.accepted}
            </span>
        );
    }

    if (status === 'not_approved') {
        return (
            <span className="text-bold text-danger" style={{whiteSpace: 'nowrap'}}>
                <i className="fa fa-fw fa-times"></i> {window.__js_bid_reviews.rejected}
            </span>
        );
    }

    return (
        <span className="text-bold text-warning" style={{whiteSpace: 'nowrap'}}>
            <i className="fa fa-fw fa-question-circle"></i> {window.__js_bid_reviews.review_pending}
        </span>
    );
}

const StatusCell = ({data, stageNum}) => {
    const stageObject = data.stages[`stage${stageNum}`];

    if (!stageObject) {
        return null;
    }

    return (
        <div>
            <StatusItem status={stageObject.status}/>
            {
                stageObject.has_attachment
                    ? <div>
                        <a href={stageObject.attachment_url} target="_blank">
                            <span style={{whiteSpace: 'nowrap'}}>
                                <i className="fa fa-fw fa-download"></i> {window.__js_general.download}
                            </span>
                        </a>
                    </div>
                    : null
            }
        </div>
    );
}

const NotesCell = ({data, stageNum}) => {
    const stageObject = data.stages[`stage${stageNum}`];

    if (!stageObject) {
        return null;
    }

    return stageObject.notes;
}

const ReviewedAtCell = ({data, stageNum}) => {
    const stageObject = data.stages[`stage${stageNum}`];

    if (!stageObject) {
        return null;
    }

    return toHumanDateTime(fromSystemDateTime(stageObject.reviewed_at));
}

const TableRow = ({data}) => {
    return (
        <tr>
            <td>{data.assessor.name}</td>
            <td>
                <StatusCell data={data} stageNum={1}/>
            </td>
            <td>
                <NotesCell data={data} stageNum={1}/>
            </td>
            <td>
                <ReviewedAtCell data={data} stageNum={1}/>
            </td>
            <td>
                <StatusCell data={data} stageNum={2}/>
            </td>
            <td>
                <NotesCell data={data} stageNum={2}/>
            </td>
            <td>
                <ReviewedAtCell data={data} stageNum={2}/>
            </td>
            <td>
                <StatusCell data={data} stageNum={3}/>
            </td>
            <td>
                <NotesCell data={data} stageNum={3}/>
            </td>
            <td>
                <ReviewedAtCell data={data} stageNum={3}/>
            </td>
        </tr>
    );
}

export default TableRow;